import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext";

export default function Notifications() {
  const { API } = useAuth();
  const [items, setItems] = useState([]);

  const load = () => axios.get(`${API}/notifications`, { withCredentials: true }).then((r) => setItems(r.data));
  useEffect(() => { load(); axios.post(`${API}/notifications/read-all`, {}, { withCredentials: true }); }, []);

  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <div className="overline">Inbox</div>
        <h1 className="font-heading text-3xl font-semibold text-[#0A231C]">Notifications</h1>
      </div>
      {items.length === 0 ? (
        <div className="card-surface p-8 text-sm text-[#5C5C5C]">Nothing new.</div>
      ) : (
        <ul className="card-surface divide-y divide-[#F0EDE3]" data-testid="notifications-list">
          {items.map((n) => (
            <li key={n.id} className="p-4" data-testid={`notification-${n.id}`}>
              <div className="overline">{n.type.replace(/_/g, " ")}</div>
              <div className="text-sm mt-1">{n.message}</div>
              <div className="text-xs text-[#A3A3A3] mt-1">{new Date(n.created_at).toLocaleString()}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
